/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HideListingInput = {|
  id: string,
  removed: boolean,
  countryCode?: ?string,
  clientMutationId?: ?string,
|};
export type AggregatesListingHideMutationVariables = {|
  input: HideListingInput
|};
export type AggregatesListingHideMutationResponse = {|
  +hideListing: ?{|
    +aggregatesListing: ?{|
      +id: string,
      +removed: boolean,
    |}
  |}
|};
export type AggregatesListingHideMutation = {|
  variables: AggregatesListingHideMutationVariables,
  response: AggregatesListingHideMutationResponse,
|};
*/


/*
mutation AggregatesListingHideMutation(
  $input: HideListingInput!
) {
  hideListing(input: $input) {
    aggregatesListing {
      id
      removed
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HideListingPayload",
    "kind": "LinkedField",
    "name": "hideListing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AggregatesListing",
        "kind": "LinkedField",
        "name": "aggregatesListing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "removed",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AggregatesListingHideMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AggregatesListingHideMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "37da9972c14ce261ecc3101ea843dccf",
    "id": null,
    "metadata": {},
    "name": "AggregatesListingHideMutation",
    "operationKind": "mutation",
    "text": "mutation AggregatesListingHideMutation(\n  $input: HideListingInput!\n) {\n  hideListing(input: $input) {\n    aggregatesListing {\n      id\n      removed\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd7c6e34f5e2679f46da8516d8590e78e';

export default node;
